import { AccountInfoResult, Deploy } from '@block-explorer/entities';

import { MessageData } from './types';
import { deriveAccountInfo } from '../../utils/account.tsx';

const prepareActionMessageData = (
  deploy: Deploy,
  getAccountInfo: <T>(hash: string) => T | null | undefined
): MessageData => {
  const { entryPoint, args } = deploy;

  const entryPointName = entryPoint?.name || '';

  const actionName = {
    add_bid: 'Add bid',
    withdraw_bid: 'Withdraw bid',
    activate_bid: 'Activate bid',
    delegate: 'Delegate',
    undelegate: 'Undelegate',
    redelegate: 'Redelegate',
  };

  const prefix = entryPointName === 'delegate' ? 'to' : 'from';
  const validatorInfo = getAccountInfo<AccountInfoResult>(
    args?.validator?.parsed as string
  );
  const newValidatorInfo = getAccountInfo<AccountInfoResult>(
    args?.new_validator?.parsed as string
  );

  const validatorInfoDetails =
    validatorInfo &&
    deriveAccountInfo(
      validatorInfo?.account_info || validatorInfo?.centralized_account_info
    );
  const newValidatorInfoDetails =
    newValidatorInfo &&
    deriveAccountInfo(
      newValidatorInfo?.account_info ||
        newValidatorInfo?.centralized_account_info
    );

  const actionOutcome: Partial<MessageData> = {
    prefix1: prefix,
    account1: {
      publicKey: args?.validator?.parsed as string,
      logo: validatorInfoDetails?.logo || undefined,
      ...validatorInfo,
    },
    prefix2: args?.new_validator ? 'to' : '',
    account2: {
      publicKey: args?.new_validator?.parsed as string,
      logo: newValidatorInfoDetails?.logo || undefined,
      ...newValidatorInfo,
    },
  };

  return {
    entryPointName: entryPointName,
    actionName: actionName[entryPointName] || entryPointName,
    ...actionOutcome,
  };
};

const prepareActionMessageDataForHome = (
  deploy: Deploy,
  getAccountInfo: <T>(hash: string) => T | null | undefined
): MessageData | null => {
  const { callerPublicKey, callerHash } = deploy;

  const messageObject = prepareActionMessageData(deploy, getAccountInfo);
  const actionOutcome: Partial<MessageData> = {
    callerPrefix: 'by',
    callerAccount: {
      publicKey: callerPublicKey || callerHash,
    },
  };

  if (messageObject === null) {
    return null;
  }

  return {
    ...messageObject,
    ...actionOutcome,
  };
};

export const auctionMessage = () => {
  const getRelevantAccountHashesFromArgs = () => {
    return ['validator', 'new_validator'];
  };

  return {
    prepareActionMessageData,
    prepareActionMessageDataForHome,
    getRelevantAccountHashesFromArgs,
  };
};
